"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLibraryManifestBuilder = void 0;
var hostManifestBuilder_1 = require("./hostManifestBuilder");
function createLibraryManifestBuilder(_a) {
    var topology = _a.topology;
    var manifest = {
        hosts: {},
        assets: [],
        statics: {},
        library: {
            url: topology.url,
            artifactId: topology.artifactId,
            namespace: topology.namespace,
            environment: {},
        },
    };
    var hostBuilders = {};
    return {
        isHostExist: function (host) {
            return !!manifest.hosts[host];
        },
        getHostBuilder: function (host) {
            if (!hostBuilders[host]) {
                hostBuilders[host] = hostManifestBuilder_1.createHostManifestBuilder({ host: host });
            }
            return hostBuilders[host];
        },
        addHotBundle: function (url) {
            manifest.library.environment.hot = url;
            this.addLibraryAsset(url, 'hot', 'js');
            return this;
        },
        addWebpackRuntimeBundle: function (url) {
            manifest.library.environment.runtime = url;
            this.addLibraryAsset(url, 'webpack-runtime', 'js');
            return this;
        },
        addLibraryAsset: function (url, type, extension) {
            if (extension === void 0) { extension = 'unknown'; }
            manifest.assets.push({ type: type, extension: extension, url: url });
            return this;
        },
        addLibraryStatics: function (statics) {
            manifest.statics = statics;
            return this;
        },
        build: function () {
            var hosts = {};
            Object.keys(hostBuilders).forEach(function (host) {
                hosts[host] = hostBuilders[host].build();
            });
            return __assign(__assign({}, manifest), { hosts: hosts });
        },
    };
}
exports.createLibraryManifestBuilder = createLibraryManifestBuilder;
//# sourceMappingURL=libraryManifestBuilder.js.map